import Vue from 'vue';
import App from './App.vue';
import { configureBackend } from './helpers/index';
import VueMask from 'v-mask';
import AsyncComputed from 'vue-async-computed';
import router from './helpers/router';
import { store } from './store/index';
import VeeValidate from 'vee-validate';
import Vuelidate from 'vuelidate';
import VueSidebarMenu from 'vue-sidebar-menu';
import VueToast from 'vue-toast-notification';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import LoadScript from 'vue-plugin-load-script';
import VueClipboard from 'vue-clipboard2';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueCompositionApi from '@vue/composition-api';

Vue.use(VueCompositionApi);
Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(AsyncComputed);
Vue.use(LoadScript);
Vue.use(BootstrapVueIcons);
Vue.use(BootstrapVue);
Vue.config.productionTip = false;
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
});
Vue.use(VueSidebarMenu);
Vue.use(VueToast);
Vue.use(VueClipboard);
if (process.env.NODE_ENV === 'mock') {
  configureBackend();
}

const app = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
});

window.app = app;
